import { ActionType } from '../../../../types/action';

/**
 * Formate le type d'action pour l'affichage
 * @param type Le type d'action à formater
 * @returns Le libellé formaté pour l'affichage
 */
export const formatActionType = (type: ActionType): string => {
  switch (type) {
    case 'call':
      return 'Appel';
    case 'visit':
      return 'Visite';
    case 'email':
      return 'Email';
    case 'note':
      return 'Note';
    case 'update':
      return 'Mise à jour';
    case 'create':
      return 'Création';
    case 'category_change':
      return 'Changement de catégorie';
    default:
      return type.charAt(0).toUpperCase() + type.slice(1);
  }
};

